import { createContext, type ReactNode } from 'react';

export const CurrentOrganizationIdContext = createContext<string | null>(null);

export function CurrentOrganizationIdProvider({
  children,
  value,
}: {
  children: ReactNode;
  value: string;
}) {
  return (
    <CurrentOrganizationIdContext.Provider value={value}>
      {children}
    </CurrentOrganizationIdContext.Provider>
  );
}
